module.exports = __webpack_public_path__ + "static/bg-page-5-40ffabce4313c0b6763b5585d16b12bf.jpg";